import { useSelector } from "react-redux";
import { ThemeSettings } from "./theme/Theme";
import RTL from "./layouts/full/shared/customizer/RTL";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { RouterProvider } from "react-router";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/Store";
import router from "./routes/Router";
import { ConfirmProvider } from "./context/ConfirmContext";
import GlobalLoadingOverlay from "./components/common/GlobalLoadingOverlay";


function App() {
  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.customizer);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={theme}>
            <RTL direction={customizer?.activeDir || "ltr"}>
              <CssBaseline />
              <ConfirmProvider>
                <RouterProvider router={router} />
              </ConfirmProvider>
              <GlobalLoadingOverlay />
            </RTL>
          </ThemeProvider>
       </PersistGate>
    </Provider>
  );
}

export default App;
